import styled from 'styled-components';

export const AutopayCustomBankAccountContainer = styled.div`
  width: 360px;

  ${({ theme }) => `
    @media screen and (max-width: ${theme.breakpoints.small}) {
      width: 100%;
    }
  `}
`;

export const AutopayStyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 60px;
`;

export const AutopayFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 16px;
`;
